import {nanoid} from "nanoid/non-secure";

export const getGalleryCategoryId = category => typeof category === 'object' && category !== null
    ? category.value ?? category.id : category;

export const getGalleryImage = item => item?.imageState?.__cx__?.key || item?.sourceState?.__cx__?.key
    || item?.image || item?.source;

export const hasGalleryText = value => typeof value === 'string' && (
    value.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;|&#xA0;/gi, ' ').trim().length > 0
    || /<(?:img|video|audio|iframe|svg|object|embed)\b/i.test(value));

export const getVisibleGalleryItems = value => (Array.isArray(value) ? value : []).filter(item =>
    item && !item.isDeleted && (getGalleryImage(item) || (typeof item.title === 'string' && item.title.trim()) || hasGalleryText(item.text)));

export const isGalleryBatchReady = files => files.length > 0 && files.every(file => file.status === 'ready' && file.key);

export const createGalleryBatch = (files, category, details = {}) => {
    if (!isGalleryBatchReady(files)) throw new Error('Wait for every image to upload, or remove images that could not upload.');
    const categoryId = getGalleryCategoryId(category);
    return files.map(file => {
        const values = details[file.id] || {};
        const itemCategory = Object.prototype.hasOwnProperty.call(values, 'category')
            ? getGalleryCategoryId(values.category) : categoryId;
        const title = typeof values.title === 'string' ? values.title.trim() : '';
        return {
            id: nanoid(),
            image: file.key,
            ...(file.pintura?.imageState ? {imageState: file.pintura.imageState} : {}),
            ...(itemCategory ? {category: itemCategory} : {}),
            ...(title ? {title} : {})
        };
    });
};

export const appendGalleryBatch = (existing, added, positions, inherited) => {
    // List can display old entries without IDs, but saved Positions must refer
    // to persistent IDs. Assign those once when the batch is committed.
    const items = Array.isArray(existing) ? existing.map(item => item.id ? item : {...item, id: nanoid()}) : [];
    const result = {items: [...items, ...added]};
    if (inherited || positions?.length) {
        const visible = items.filter(item => !item.isDeleted);
        if (positions?.length) visible.sort((a, b) => positions.indexOf(a.id) - positions.indexOf(b.id));
        result.positions = [...visible.map(item => item.id), ...added.map(item => item.id)];
    }
    return result;
};
